import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history', // hash | history
  routes: [
    {
      path: '/',
      name: 'Index',
      component: resolve => require(['../pages/Index.vue'], resolve),
    },
    {
      path: '/exercise',
      name: 'Exercise',
      component: resolve => require(['../pages/Exercise.vue'], resolve),
    },
    {
      path: '/session_edit',
      name: 'SessionEdit',
      component: resolve => require(['../pages/ExerciseEdit.vue'], resolve),
    },
    {
      path: '/login',
      name: 'Login',
      component: resolve => require(['../pages/Login.vue'], resolve),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js